import React, {Component} from 'react';
import {withRouter, Route} from 'react-router-dom';
import {connect} from 'react-redux';
import LoginComponent from "../../Containers/Authentication";
import { withTranslation, withNamespaces } from "react-i18next";


// utils
import * as Const from '../../Data/const'

class LoginPage extends Component {

    constructor(props) {
        super(props);

        this.handleCloseModal = this.handleCloseModal.bind(this);
    }

    componentDidMount() {
        // 토큰 지우기용
        //localStorage.setItem(Const.TOKEN['user'], '')
        if (this.props.eSESSION.user) {
            this.handleCloseModal();
        }
    }

    componentDidUpdate(prevProps) {
        if (prevProps.eSESSION.user !== this.props.eSESSION.user) {
            this.handleCloseModal();
        }
    }

    handleCloseModal() {
        Const.userAppCloseActivity();
    }

    render() {
        return (
            <LoginComponent onRef={(ref) => { this.loginRef = ref;}} loginSuccess={this.handleCloseModal} handleClose={this.handleCloseModal}
                            modalContents={{title: this.props.t('sns_login'), info: this.props.t('login_benefit')}}/>
        )
    }
}

export default connect((state) => {
    return {
        eSESSION: state.data.eSESSION.eSESSION
    }
})(withRouter(withTranslation()(LoginPage)));
